<template>
  <div class=" bpmDict">
    <div class="core layui-card">
      <div class="layui-form layui-card-header layuiadmin-card-header-auto">
        <div class="layui-form-item query-box">
          <div class="layui-inline">
            节点名称
          </div>
          <div class="layui-inline">
            <input
              class="layui-input"
              autocomplete="off"
              placeholder="请输入节点名称"
              v-model="t_dic.queryObject['NODE_NAME:2']"
            />
          </div>
          <!-- <div class="layui-inline"> -->
          <button class="layui-btn layuiadmin-btn-list" @click="handleSearch" title="查询">查询</button>
          <button class="layui-btn" @click="handleReset" title="重置">重置</button>
          <button class="layui-btn layuiadmin-btn-role" @click="handleAdd">
            添加
          </button>
          <!-- </div> -->
        </div>
      </div>
      <!-- <div class="layui-card-body"> -->
      <!-- <div class="layui-table-body layui-table-main"> -->
      <layui-tabletree
        :outside="this.outside"
        ref="t_dic"
        :expand-level="1"
        table-name="YW_FLOW_NODE"
        show-field="NODE_NAME"
        treeid="NODE_ID"
        treepid="NODE_PID"
        jb-field="NODE_JB"
        :default-condition="defaultQuery"
        :sort="['NODE_ORDER:ASC']"
        :page-size="15"
        :page-range="6"
        :page-options="[15, 25, 50, 100]"
        @tabletree-event-addchild="addchild($event.data)"
        @tabletree-event-treeedit="treeEdit($event.data)"
        @tabletree-event-treedel="treeDel($event.data)"
        @tabletree-event-move="handleMove($event)"
        height="full-170"
      >
        <div>
          <div field="NODE_NAME" title="节点名称" align="center">
            <script type="text/html" v-pre>
              {{ d.NODE_NAME }}
               <div class="sort-btns">
                <div class="sort-btn up" data-direction="up" event-stop lay-event="move">上移</div>
                <div class="sort-btn down" data-direction="down" event-stop lay-event="move">下移</div>
              </div>
            </script>
          </div>
          <div field="NODE_JB" title="级别" align="center" width="80"></div>
          <div field="NODE_REMARKS" title="节点备注" align="center" width="250"></div>
          <!-- <input class="layui-input" type="text" name="sort" value="{{d.sort || ''}}" lay-filter="sortIpt"/> -->
          <!-- <div field="STATE" title="排序" width="150">
            <script type="text/html" id="sortIpt" v-pre>
              <div class="sort-box">
                {{d.NODE_ORDER }}
              </div>
            </script>
          </div> -->
          <!-- <div field="STATE1" title="排序" width="150">
            <script type="text/html" id="sortIpt" v-pre>
              <div class="sort-btns">
                <div class="sort-btn" data-direction="up" lay-event="move">上移</div>
                <div class="sort-btn" data-direction="down" lay-event="move">下移</div>
              </div>
            </script>
          </div> -->
          <div field="_opt" width="250" align="center" title="操作">
            <script type="text/html" v-pre>
              {{#  if(d.NODE_JB < 3){ }}
              <a class="layui-btn-xs" lay-event="addchild">新增下级</a>
              {{#  } }}
              <a class="layui-btn-xs" lay-event="treeedit">编辑</a>
              <a class="layui-btn-xs layui-btn-xs-danger" lay-event="treedel">删除</a>
            </script>
          </div>
        </div>
      </layui-tabletree>
      <!-- </div> -->
      <!-- </div> -->
    </div>

    <layui-form class="dictFormLayer" ref="dictForm" :after-save="treeAfterSave" :outside="this.outside">
      <template slot-scope="{ scope }">
        <div class="layui-form rowEdit-row">
          <div class="layui-form-item" v-if="scope.editRow.PARENT_DIC">
            <label class="layui-form-label">上级字典：</label>
            <div class="layui-input-inline">
              <input
                type="text"
                v-model="scope.editRow.PARENT_DIC"
                autocomplete="off"
                class="layui-input"
                disabled="disabled"
              />
            </div>
          </div>
          <div class="layui-form-item">
            <label class="layui-form-label"> <span class="x-red">*</span>节点名称：</label>
            <div class="layui-input-inline">
              <input
                type="text"
                v-model="scope.editRow.NODE_NAME"
                autocomplete="off"
                class="layui-input"
                name="NODE_NAME"
              />
            </div>
          </div>
          <div class="layui-form-item">
            <label class="layui-form-label"> <span class="x-red">*</span>级别：</label>
            <div class="layui-input-inline">
              <input
                type="text"
                v-model="scope.editRow.NODE_JB"
                autocomplete="off"
                class="layui-input"
                name="NODE_JB"
                disabled="disabled"
              />
            </div>
          </div>
          <div class="layui-form-item">
            <label class="layui-form-label">排序：</label>
            <div class="layui-input-inline">
              <input
                type="text"
                v-model="scope.editRow.NODE_ORDER"
                autocomplete="off"
                class="layui-input"
                name="NODE_ORDER"
              />
            </div>
          </div>
          <div class="layui-form-item">
            <label class="layui-form-label">备注：</label>
            <div class="layui-input-inline">
              <textarea v-model="scope.editRow.NODE_REMARKS" class="layui-textarea" />
            </div>
          </div>
          <div class="layui-form-item">
            <label class="layui-form-label"></label>
            <layui-fileupload
              class="layui-input-inline"
              v-model="scope.editRow.NODE_FS"
              :business-table="''"
              :business-field="scope.editRow.NODE_FS"
            >
              <template slot-scope="{ scope }">
                <button type="button" class="file-upload layui-btn layui-btn-primary" @click="scope.upload()">
                  <i class="layui-icon"></i>上传文件
                </button>
              </template>
            </layui-fileupload>
          </div>
        </div>

        <div class="layui-form-btn">
          <!-- <label for="L_repass" class="layui-form-label"> </label> -->
          <button class="layui-btn" @click="handleSaveNode">保存</button>
          <button class="layui-btn" @click="$refs.dictForm.close()">关闭</button>
        </div>
      </template>
    </layui-form>
  </div>
</template>

<script>
import { zIndexUp, zIndexDown } from '@/utils/index'
export default {
  name: 'BpmDict',
  data() {
    return {
      defaultQuery: { NODE_JB: '1', 'DELETED:0': '0' },
      t_dic: {
        queryObject: {}
      },
      outside: '.bpm-content'
    }
  },
  mounted() {
    this.t_dic = this.$refs.t_dic
    this.layui.form.on('switch(sexDemo)', obj => {})
  },
  methods: {
    handleMove: function(ev) {
      layui.stope(ev)
      let direction = ev.layRow.cur.attr('data-direction')
      let trIdx = ev.layRow.tr.attr('data-index') * 1
      let row = ev.data
      let { data: list, pageInfo } = this.$refs['t_dic']

      let pNode = { treeList: list },
        idx = trIdx
      row.NODE_PID !== -1 &&
        treeNodeAddProp(list, { childrenProp: 'treeList', initPos: [] }, (node, pos) => {
          if (node.NODE_ID === row.NODE_PID) {
            pNode = node
          }
          if (node.NODE_ID === row.NODE_ID) {
            idx = pos.reverse()[0]
          }
          return node
        })

      // let len = pNode.treeList.length
      // if (direction === 'up') {
      //   if (idx === 0) return
      //   pNode.treeList = zIndexUp(pNode.treeList, idx)
      // } else if (direction === 'down') {
      //   if (idx + 1 === len) return
      //   pNode.treeList = zIndexDown(pNode.treeList, idx)
      // } else {
      //   return
      // }

      // let l = pageInfo.totalNum - pageInfo.pageSize * (pageInfo.pageIndex - 1)
      // let rows = pNode.treeList.map((item, index) => {
      //   return { IS_NEW: false, NODE_ORDER: l - index, NODE_ID: item.NODE_ID }
      // })

      let rows = [],
        cur = {},
        target = {}

      if (direction === 'up') {
        if (idx !== 0) {
          cur = pNode.treeList[idx]
          target = pNode.treeList[idx - 1]
        } else {
          return
        }
      } else if (direction === 'down') {
        if (idx + 1 != pNode.treeList.length) {
          cur = pNode.treeList[idx]
          target = pNode.treeList[idx + 1]
        } else {
          return
        }
      } else {
        return
      }
      let tmp = cur.NODE_ORDER
      cur.NODE_ORDER = target.NODE_ORDER
      target.NODE_ORDER = tmp
      rows = [
        { IS_NEW: false, NODE_ID: cur.NODE_ID, NODE_ORDER: cur.NODE_ORDER },
        { IS_NEW: false, NODE_ID: target.NODE_ID, NODE_ORDER: target.NODE_ORDER }
      ]

      this.layer.showLoading({ targetEl: $('.bpm-content') })
      this.api.saveList('YW_FLOW_NODE', rows, 'zIndexUpDown').then(response => {
        this.layer.closeLoading()

        if (response.errorMsg) {
          this.layer.openAlert(response.errorMsg, false, undefined, {
            targetEl: $('.bpm-content')
          })
        } else {
          if (direction === 'up') {
            pNode.treeList = zIndexUp(pNode.treeList, idx)
          } else if (direction === 'down') {
            pNode.treeList = zIndexDown(pNode.treeList, idx)
          }
          this.$refs['t_dic'].getTableTreeObj().refresh(list)
        }
      })
    },

    handleSearch: function() {
      let query = this.t_dic.queryObject
      query['NODE_JB'] = ''

      this.$refs.t_dic.search()
    },
    handleReset: function() {
      let query = this.t_dic.queryObject
      // query['NODE_JB'] = 1
      delete query['NODE_JB']
      this.$refs.t_dic.reset()
    },
    handleAdd: function() {
      let t_dic = this.$refs.t_dic
      this.$refs.dictForm.open('添加根节点', '400', 'auto', undefined, undefined, { skin: 'overflowAuto'})
      this.$refs.dictForm
        .setDefaultValue('NODE_JB', 1)
        .setDefaultValue('NODE_PID', -1)
        .setDefaultValue('PARENT_DIC', null)
        // totalNum 总数会因为添加删除不准确
        // .setDefaultValue('NODE_ORDER', moment().format('YYYYMMDDhhmmss'))
        .setDefaultValue('NODE_ORDER', t_dic.pageInfo.totalNum + 1)

      this.$refs.dictForm.setEditRow()
    },

    handleSaveNode: function() {
      this.$refs.dictForm.callableSave(this.$refs.t_dic, true)
    },

    treeAfterSave(row, isNew) {
      var t_dic = this.$refs.t_dic
      var dictForm = this.$refs.dictForm
      var treeObjData = t_dic.getTableTreeObj().getTableTreeData()
      dictForm.close()
      if (row[t_dic.jbField] == 1) {
        //根节点
        if (isNew) {
          // 新增
          t_dic.data.push(row)
          treeObjData.push(row)

          this.layer.openSuccess('添加成功!', {
            targetEl: $('.bpm-content'),
            title: '提示'
          })
          t_dic.load()
          return
        } else {
          // 编辑
          for (var i = 0; i < t_dic.data.length; i++) {
            var item = t_dic.data[i]
            if (item[t_dic.treeid] == row[t_dic.treeid]) {
              t_dic.data[i] = row
              treeObjData[i] = row
              break
            }
          }
        }
        treeObjData.sort((a, b) => (a.NODE_ORDER || 0) - (b.NODE_ORDER || 0))
      } else {
        // 处理非根节点
        var parent = []
        t_dic.findNodeById(row[t_dic.treepid], t_dic.data, parent)
        var parent = parent[0]
        if (!parent.treeList) parent.treeList = []
        if (isNew) {
          // 新增
          parent.treeList.push(row)
        } else {
          // 编辑
          for (var i = 0; i < parent.treeList.length; i++) {
            var item = parent.treeList[i]
            if (item[t_dic.treeid] == row[t_dic.treeid]) {
              parent.treeList[i] = row
              break
            }
          }
        }

        row._p = true

        parent.treeList.sort((a, b) => (a.NODE_ORDER || 0) - (b.NODE_ORDER || 0))
      }
      t_dic.getTableTreeObj().refresh()
      // this.$parent.$refs.nodeTree.load()
    },
    addchild(row) {
      var t_dic = this.$refs.t_dic
      this.$refs.dictForm.open('添加下级节点', '400', 'auto', undefined, undefined, { skin: 'overflowAuto' })
      // this.$refs.dictForm.openWin('添加下级节点')
      var parentJb = row[t_dic.jbField]
      this.$refs.dictForm.setDefaultValue('NODE_JB', Number(parentJb) + 1)
      this.$refs.dictForm.setDefaultValue('PARENT_DIC', row.NODE_NAME)
      // this.$refs.dictForm.setDefaultValue('DIC_CATEGORY', row.DIC_CATEGORY);
      this.$refs.dictForm.setDefaultValue('NODE_PID', row.NODE_ID)
      this.$refs.dictForm.setDefaultValue('NODE_ORDER', row.treeList && row.treeList.length ? row.treeList.length + 1: 1)
      // 点击父级级节点未展开时，重置node_order
      if(!row.childLoaded) {
          this.$refs.t_dic.loadChild(row,(data)=>{
            this.$refs.dictForm.setDefaultValue('NODE_ORDER', data.length + 1)
            this.$refs.dictForm.setEditRow()
          })
      }
      this.$refs.dictForm.setEditRow()
    },
    treeEdit(row) {
      this.$refs.dictForm.open('编辑当前节点', '400', 'auto', undefined, undefined, { skin: 'overflowAuto'})
      this.$refs.dictForm.setEditRow(row)
    },
    treeDel(row) {
      var t_dic = this.$refs.t_dic
      var p2 = { 'DELETED:0': 0 }
      var pid = row[t_dic.treeid]
      p2[t_dic.treepid] = pid
      this.api.queryList(t_dic.tableName, { p2: p2, p9: t_dic.selectFields, p10: t_dic.sort }).then(response => {
        var result = response.result
        if (result.length == 0) {
          this.layer.openConfirm(
            '<span style="color:red">确定要删除该节点吗?</span>',
            () => {
              // this.api.delRows(t_dic.tableName, { p5: [row] })
              this.api
                .save(t_dic.tableName, { NODE_ID: row.NODE_ID, DELETED: '1', IS_NEW: false }, 'nodeDel')
                .then(response => {
                  t_dic.getTableTreeObj().delTreeNode(pid)
                  this.layer.openSuccess('删除成功!', {
                    targetEl: $('.bpm-content'),
                    title: '提示'
                  })

                  // this.$parent.$refs.nodeTree.load()
                })
            },
            null,
            { targetEl: $('.bpm-content'), title: '提示' }
          )
        } else {
          this.layer.openAlert('该节点还有子节点，不能删除！', false, undefined, {
            targetEl: $('.bpm-content'),
            title: '提示'
          })
        }
      })
    }
  }
}
</script>

<style lang="postcss">
.bpmDict {
  & .overflowAuto {
    overflow: auto;
  }

  & .layuiadmin-card-header-auto {
    margin: 0;
  }

  & .dictFormLayer {
    height: 100%;
    overflow: auto;

    & .layui-form-btn {
      height: 60px;
      line-height: 60px;
    }
  }

  & .rowEdit-row.layui-form {
    padding: 20px 15px 60px;

    & .layui-form-item {
      margin-bottom: 15px;
      display: flex;
    }
    & .layui-form-label {
      padding-left: 0;
    }
    & .layui-input-inline {
      flex: 1;
      margin: 0;
    }

    & .file-upload {
      height: 32px;
      line-height: 32px;
      background: #fff;
    }
  }

  & .sort-box {
    display: flex;
    align-items: center;
    height: 100%;

    & .layui-input {
      padding-right: 10px;
    }
  }

  & .layui-table-hover .sort-btns {
    display: inline-flex;
  }
  & .sort-btns {
    /* display: inline-flex; */
    display: none;
    align-items: center;
    height: 100%;
    margin-left: 6px;
    & .sort-btn {
      margin-left: -4px;
      padding: 3px 8px;
      /* border: 1px solid #ccc; */
      line-height: 1;
      font-size: 12px;
      cursor: pointer;
      color: #fff;
      border-radius: 10px;
      transform: scale(0.8);

      &.up {
        background: #00a0e9;
      }
      &.down {
        background: #00489e;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/workOrder/newBpm/bpmDict.vue